(function (fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    /* ------------------------------------*\
        TABBED SECTIONS
    \*------------------------------------*/
    [].forEach.call(document.querySelectorAll('.tabbed-sections'), (tabbedSection) => {
        [].forEach.call(tabbedSection.querySelectorAll('h4 > a'), (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                if (document.querySelector(el.getAttribute('href')).classList.contains('current')) {
                    return;
                }

                const currentTab = tabbedSection.querySelector('.tab.current');

                if (tabbedSection.querySelector('.tab.hide')) {
                    tabbedSection.querySelector('.tab.hide').classList.remove('hide');
                }
                if (tabbedSection.querySelector('.tab.show')) {
                    tabbedSection.querySelector('.tab.show').classList.remove('show');
                }
                currentTab.classList.remove('current');
                currentTab.classList.add('hide');

                tabbedSection.querySelector('h4.current').classList.remove('current');
                el.parentElement.classList.add('current');

                document.querySelector(el.getAttribute('href')).classList.add('show');
                document.querySelector(el.getAttribute('href')).classList.add('current');
            });
        });
    });
}));
